<script>
	import { showAllTopicsFilterView } from "../stores";

	export let floating = false;
</script>

<div
	class="back-button"
	class:floating
	on:click={() => {
		$showAllTopicsFilterView = false;
	}}
>
	<!-- <img src={`${PATH}assets/images/icons/back_map.svg`} /> -->
	<div>zurück zur Karte</div>
	<svg viewBox="0 0 10.2 10.3" xmlns="http://www.w3.org/2000/svg">
		<path
			fill={floating ? "#fff" : "#fa6969"}
			d="M1.04,10.109L0.064,9.132L4.124,5.072L0.064,1.012L1.04,0.035L5.1,4.096L9.16,0.035L10.137,1.012L6.077,5.072L10.137,9.132L9.16,10.109L5.1,6.049L1.04,10.109Z"
		/>
	</svg>
</div>

<style lang="scss">
	.back-button {
		$red: #fa6969;
		width: fit-content;
		display: flex;
		align-items: center;
		gap: 8px;
		font-weight: $medium;
		cursor: pointer;

		svg {
			width: 12px;
			height: 12px;
		}

		&:not(.floating) {
			color: $red;
			border: 1px solid rgba(255, 78, 78, 0.5);
			background-color: rgba($red, 0.24);
			opacity: 0.8;
			border-radius: 4px;
			font-size: 12px;
			line-height: 110%; /* 13.2px */
			padding: 5px 8px;
		}

		&.floating {
			color: $white;
			padding: 10px 15px;
			box-shadow: 0px 0px 39px 0px rgba(0, 0, 0, 0.5);
			background-color: rgba($red, 0.75);
			backdrop-filter: blur(5px);
			-webkit-backdrop-filter: blur(5px);
			border-radius: 71px;
			font-size: 16px;
			line-height: 24px; /* 150% */
			position: sticky;
			position: sticky;
			transform: translate(0, -100%);
			bottom: 10px;

			// @media (max-width: $breakpoint-mobile-l) {
			// 	background-color: rgba($red, 0.95);
			// }
		}
	}
</style>
